import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VProgressCircular,{staticStyle:{"margin-left":"10px"},attrs:{"width":3,"color":_vm.cor,"indeterminate":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }